import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import {
  Box,
  Inline,
  Loader,
  Rating,
  Stack,
  Text,
  Tiles,
} from 'braid-design-system';

import type { CompanyReviewSummaryBreakdown } from '../../../models/CompanyProfile';
import { formatCount, formatRating } from '../../../utils/rating';
import translations from './.vocab';

interface Props {
  locale: Locale;
  model?: CompanyReviewSummaryBreakdown[];
}

export const ReviewSummaryBreakdown = ({ model, locale }: Props) => {
  const { t } = useTranslations(translations);
  if (!model) {
    return <Loader />;
  }
  const reviewSummaryBreakdowns = model;

  return (
    <Stack space="large">
      <Tiles columns={[1, 3]} space={['xlarge', 'large']}>
        {reviewSummaryBreakdowns &&
          reviewSummaryBreakdowns.map((rating, index) => (
            <Box key={`rating-${index}`}>
              {rating && (
                <Stack space="small">
                  <Text align="left">{rating.description}</Text>
                  <Inline space="small" align="left">
                    <Rating rating={rating.rating ?? 1} variant="starsOnly" />
                    <Text weight="strong">
                      {formatRating(rating.rating ?? 1, 1)}
                    </Text>
                    <Text size="xsmall">
                      {t('ratings', {
                        count: formatCount(rating.count ?? 0, locale),
                      })}
                    </Text>
                  </Inline>
                </Stack>
              )}
            </Box>
          ))}
      </Tiles>
    </Stack>
  );
};
